<template>
    <div class='custom-html-element' :style='[custom_styles.container]' :class="[classes.container]">
        <div class='custom-html-placeholder' v-if='page_builder_mode' v-show='element.element_config.config.content == ""'>Custom HTML</div>
        <div :style='[styles, custom_styles.html]' :class="[classes.html]" v-html='element.element_config.config.content'>
            
        </div>
    </div>
</template>

<script>
import {formatStyles, importDynamicCss, formatUrlForCachedFiles} from "@/global/modules/functions.js";
import format_custom_styles from "@/page_builder/builder/builder_tools/functions/format_custom_styles.js";
import {importJavascriptFromBlob, importJavaScript}  from "@/page_builder/builder/builder_tools/functions/pagebuilder_functions.js";

export default {
    components: {},
    props:['element', 'page_builder_mode', 'content_type'],
    mixins: [format_custom_styles],
    data(){
        return{
            styles:{},
            classes: {},
            module: null
        }
    },
    methods:{
        setStyles(){
            this.styles = this.element.element_config.compiled_styles;

        if(this.element.element_config.compiled_classes != null){
                this.classes = this.element.element_config.compiled_classes;
            }
        },
        createCustomStyleSheet(){
            importDynamicCss({
                css: this.element.element_config.config.css,
                scope_to: `#${this.element.id}`,
                stylesheet_id: `custom_html_element_style_sheet_${this.element.id}`
            });
        },
        async importJs(){
            if(this.page_builder_mode){
                if(this.element.element_config.config.js != ''){
                    importJavascriptFromBlob(this.element.element_config.config.js);
                }
            }
            else{
                let url = formatUrlForCachedFiles(this.$route.path);
                url += this.content_type;

                if(url == '/' || url == ''){
                    url = 'home';
                }

                importJavaScript(url, `${this.element.id}.min.js`);
            }
        }
    },
    watch:{
        'element': {
            handler(){
                this.setStyles();
                this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
            },
            deep: true
        },
        'element.element_config.config.css': function(){
            this.createCustomStyleSheet();
            // this.importJs(); //Add back in when added JS
        }
    },
    mounted(){
        this.setStyles();
        this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
        this.createCustomStyleSheet();
        this.importJs();
    }

}
</script>

<style lang="scss" scoped>
.custom-html-element{
    width: 100%;
}

.custom-html-placeholder{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #385170;
    height: 100px;
    width: 100%;
}

.empty-space-text{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-size: 1.2rem;
    color: #385170;
}
</style>